export default {
  BASIC: 'BASIC',
  SMART: 'SMART',
}
